import React from 'react'
import { animated, useSpring } from '@react-spring/web'

export default function FadeIn({ children }) {
  const styles = useSpring({
    from: {
      opacity: 0,
    },
    to: {
      opacity: 1,
    },
    config: {
      tension: 250,
    },
  })

  return <animated.div style={styles}>{children}</animated.div>
}
